import moment from "moment";

export default function newVideoDate(date: any) {
  const dayDate = moment(date).utc().locale("pt-br").format("LL");
  const hoursAgo = moment(date).locale("pt-br").fromNow();

  return `${dayDate} (${hoursAgo})`;
}
